import { Drawer, List, Tag, Typography, Badge, Button, Icon } from 'antd';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const { Text, Paragraph } = Typography;

const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
`;

const BlacklistInfo = styled.div`
  background: #fff2f0;
  border: 1px solid #ffccc7;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 24px;
`;

const InfoText = styled(Paragraph)`
  color: #595959;
  margin-bottom: 16px !important;
`;

const ActionList = styled.ul`
  margin: 0;
  padding-left: 16px;
  color: #595959;
  
  li {
    margin-bottom: 8px;
    line-height: 1.5;
  }
`;

const ExpandButton = styled(Button)`
  &&& {
    padding: 0;
    height: auto;
    color: #262626;
    font-weight: 500;
    font-size: 12px;
    
    &:hover, &:focus {
      color: #595959;
    }
    
    .anticon {
      margin-right: 8px;
      transition: transform 0.3s;
      font-size: 10px;
    }
    
    &.expanded .anticon {
      transform: rotate(90deg);
    }
  }
`;

const ExpandedContent = styled.div`
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #ffccc7;
`;

const ListItem = styled(List.Item)`
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.3s ease;
  cursor: default;
  
  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: #fafafa;
  }
`;

const CustomerName = styled(Text)`
  color: #262626;
  font-weight: 500;
  display: block;
  margin-bottom: 4px;
  font-size: 14px;
`;

const EmailText = styled(Text)`
  color: #8c8c8c;
  font-size: 12px;
  display: block;
`;

const ListContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const CustomerInfo = styled.div`
  flex: 1;
  min-width: 0;
  margin-right: 16px;
`;

const StyledList = styled(List)`
  .ant-list-item-meta {
    margin-bottom: 0;
  }
`;

const BlacklistTag = styled(Tag)`
  margin: 0;
  padding: 4px 8px;
  font-size: 12px;
  border-radius: 4px;
`;

const ActionItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 8px;
  line-height: 1.5;
  
  .anticon {
    margin-top: 2px;
    color: #8c8c8c;
  }
`;

const getCustomerName = (log, customersById) => 
  (customersById[log.customer_id] && customersById[log.customer_id].name) || log.customer_name;

export const BlacklistDrawer = ({ isOpen, onClose, blacklistEmails }) => {
  const { customersById } = useSelector((state) => ({
    customersById: state.customersById,
  }));
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Drawer
      title={
        <DrawerHeader>
          <span>E-mails na Blacklist</span>
          <Badge count={blacklistEmails.length} style={{ backgroundColor: '#f5222d' }} />
        </DrawerHeader>
      }
      placement="right"
      onClose={onClose}
      visible={isOpen}
      width={600}
    >
      <BlacklistInfo>
        <InfoText>
          E-mails em blacklist são endereços que foram bloqueados devido a problemas de entrega ou solicitação do destinatário.
        </InfoText>
        
        <ExpandButton
          type="link"
          className={isExpanded ? 'expanded' : ''}
          onClick={() => setIsExpanded(!isExpanded)}
          icon="right"
        >
          O que fazer?
        </ExpandButton>

        {isExpanded && (
          <ExpandedContent>
            <ActionList>
              <ActionItem>
                <Icon type="mail" />
                <span>Alterar o email do usuário para outro endereço de email secundário pode ajudar.</span>
              </ActionItem>
              <ActionItem>
                <Icon type="clock-circle" />
                <span>Aguardar para que o servidor de destino remova o blacklist e os e-mails voltem a serem entregues.</span>
              </ActionItem>
            </ActionList>
          </ExpandedContent>
        )}
      </BlacklistInfo>

      <StyledList
        dataSource={blacklistEmails}
        renderItem={(item) => (
          <ListItem>
            <ListContent>
              <CustomerInfo>
                <CustomerName>{getCustomerName(item, customersById) || 'Cliente não informado'}</CustomerName>
                <EmailText>{item.email_to}</EmailText>
              </CustomerInfo>
              <BlacklistTag color="red">Blacklist</BlacklistTag>
            </ListContent>
          </ListItem>
        )}
      />
    </Drawer>
  );
}; 